import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../service/auth.service';

@Component({
    selector: 'app-mfa-verify',
    templateUrl: './mfa-verify.component.html',
    styleUrls: ['./mfa-verify.component.css']
})
export class MfaVerifyComponent implements OnInit, AfterViewInit {
    @ViewChild('codeInput') codeInput: ElementRef;
    code = '';
    message = '';
    submitting = false;

    constructor(private authservice: AuthService, private router: Router) {}

    ngOnInit() {
        if (!this.authservice.pendingMfaToken) {
            this.router.navigate(['/login']);
        }
    }

    ngAfterViewInit() {
        // Focus the code field so the user can type immediately without clicking.
        if (this.codeInput) {
            this.codeInput.nativeElement.focus();
        }
    }

    submit() {
        if (!this.code) { return; }
        this.submitting = true;
        this.authservice.verifyMfa(this.code).subscribe((res: any) => {
            this.submitting = false;
            if (res && res.status) {
                this.authservice.completeLogin(res);
                this.router.navigate(['/news']);
            } else {
                this.message = (res && res.message) || 'Invalid code.';
            }
        }, () => {
            this.submitting = false;
            this.message = 'Invalid authentication code.';
        });
    }
}
